export default (v) => {
    if (!v) {
        return '';
    }
    let hash = 0;
    for (let i = 0; i < v.length; i++) {
        hash = v.charCodeAt(i) + ((hash << 5) - hash);
    }
    let c = (hash & 0x00FFFFFF).toString(16).toUpperCase();
    return  '#' + "00000".substring(0, 6 - c.length) + c;
}




// WEBPACK FOOTER //
// ./resources/assets/js/filters/strToColor.js